import { createFileRoute } from "@tanstack/react-router";
import { listProfileLeads } from "api-client";
import { z } from "zod";

import { PROFILE_LEADS_PAGE_SIZE } from "src/components/CoachLeadList";
import { loaderHandler } from "src/lib/loaderHandler";
import { CoachLeadsPage } from "src/pages/CoachLeadsPage";

const routeSearchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
  leadId: z.string().optional(),
});

export const Route = createFileRoute("/_auth/_coach/profile/leads")({
  component: CoachLeadsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  shouldReload: false,
  loaderDeps: ({ search }) => {
    return {
      q: search.q,
      p: search.p,
      ps: search.ps,
    };
  },
  async loader({ deps }) {
    return await loaderHandler(async () => {
      const pageSize = deps.ps || PROFILE_LEADS_PAGE_SIZE;
      const leads = await listProfileLeads({
        query: {
          pageIndex: Number(deps.p) || 0,
          query: deps.q || "",
          pageSize,
        },
      }).then((response) => response.data.data);

      return {
        data: {
          leads,
          pageSize,
        },
      };
    });
  },
});
